import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null,
  },

  mutations: {
    SET_CURRENT_USER(state, payload) {
      state.currentUser = payload;
    },
  },

  actions: {

    setCurrentUser(context, user) {
      this.commit('SET_CURRENT_USER', user);
    },
  }
})
